import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=0c006eff"
import script from "./Schedule.vue?vue&type=script&lang=ts"
export * from "./Schedule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports